// extracted by mini-css-extract-plugin
export default {"footer_top_btn_part":"gototop_footer_top_btn_part__m1eGx","footer_top_btn_icon":"gototop_footer_top_btn_icon__vyP7I"};